"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var configuration_1 = require("./configuration");

var validation_1 = require("../../validation");

var ApronBackSplashKeys;

(function (ApronBackSplashKeys) {
  ApronBackSplashKeys["Apron"] = "apron";
  ApronBackSplashKeys["ApronHeight"] = "apronHeight";
  ApronBackSplashKeys["SurgeEdgeOrBackSplash"] = "surgeEdgeOrBackSplash";
  ApronBackSplashKeys["PositionOfEdgeOrBacksplash"] = "positionOfEdgeOrBacksplash";
  ApronBackSplashKeys["BacksplashHeight"] = "backsplashHeight";
  ApronBackSplashKeys["RestorablePlateDimensions"] = "restorablePlateDimensions";
})(ApronBackSplashKeys = exports.ApronBackSplashKeys || (exports.ApronBackSplashKeys = {}));

var ApronBackSplash =
/** @class */
function (_super) {
  __extends(ApronBackSplash, _super);

  function ApronBackSplash() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ApronBackSplash.prototype.handle = function () {
    var _this = this;

    if (this.prevKey && this[this.prevKey] === null) {
      return null;
    }

    var data = {};
    Object.keys(ApronBackSplashKeys).forEach(function (key) {
      var _a;

      return lodash_1.assign(data, (_a = {}, _a[ApronBackSplashKeys[key]] = _this[ApronBackSplashKeys[key]], _a));
    });
    return data;
  };

  ApronBackSplash.prototype.handleDefaults = function () {
    var defaults = this.default;
    var data = this.handle();

    if (data) {
      if (!this.isExos) {
        defaults.surgeEdgeOrBackSplash = Object.assign({}, defaults.surgeEdgeOrBackSplash, {
          default: 'withSurgeEdge'
        });
      }

      if (data.surgeEdgeOrBackSplash) {
        var typeOfInstallation = this.washBasinDimension && this.washBasinDimension.typeOfInstallation;
        defaults = typeOfInstallation && validation_1.validateSurgeEdgeOrBackSplash(typeOfInstallation, data, defaults) || defaults;

        if (validation_1.isInstanceOfError(defaults)) {
          return defaults;
        }
      }

      if (this.isVariusMed || this.isMedcare) {
        defaults.apron = Object.assign({}, defaults.apron, {
          default: 'without',
          values: ['without']
        });
      } else {
        defaults.apron = Object.assign({}, defaults.apron, {
          default: 'without',
          values: ['without', 'with']
        });
      }

      if (data.apronHeight && data.apronHeight > 0) {
        defaults = validation_1.validateApronHeight(data.apronHeight, defaults);

        if (validation_1.isInstanceOfError(defaults)) {
          return defaults;
        }
      }

      if (data.apron) {
        //  && this.builtInParts
        defaults = validation_1.validateApron(data, defaults, this.builtInParts);

        if (validation_1.isInstanceOfError(defaults)) {
          return defaults;
        }
      }
    }

    return defaults;
  };

  Object.defineProperty(ApronBackSplash.prototype, "apron", {
    get: function get() {
      if (!this.apronBackSplash) {
        return this.getDefault(configuration_1.ConfigurationKeys.ApronBackSplash, ApronBackSplashKeys.Apron).default;
      }

      if (this.isVariusMed && this.apronBackSplash.apron === 'with') {
        return 'without';
      }

      return this.apronBackSplash.apron;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ApronBackSplash.prototype, "apronHeight", {
    get: function get() {
      if (this.apronBackSplash) {
        if (this.isVariusMedRwt) {
          return null;
        }

        if (this.apron === 'with') {
          return this.apronBackSplash.apronHeight;
        }

        return null;
      }

      return this.getDefault(configuration_1.ConfigurationKeys.ApronBackSplash, ApronBackSplashKeys.ApronHeight).default;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ApronBackSplash.prototype, "restorablePlateDimensions", {
    get: function get() {
      if (this.apronBackSplash) {
        return this.apronBackSplash.restorablePlateDimensions;
      }

      return this.getDefault(configuration_1.ConfigurationKeys.ApronBackSplash, ApronBackSplashKeys.RestorablePlateDimensions).default;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ApronBackSplash.prototype, "surgeEdgeOrBackSplash", {
    get: function get() {
      if (!this.apronBackSplash || this.isNewTrough) {
        if (!this.isExos) {
          return 'withSurgeEdge';
        } else {
          return this.getDefault(configuration_1.ConfigurationKeys.ApronBackSplash, ApronBackSplashKeys.SurgeEdgeOrBackSplash).default;
        }
      }

      return this.apronBackSplash.surgeEdgeOrBackSplash;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ApronBackSplash.prototype, "positionOfEdgeOrBacksplash", {
    get: function get() {
      if (this.apronBackSplash) {
        if (this.surgeEdgeOrBackSplash === 'withBackSplash' || this.surgeEdgeOrBackSplash === 'withSurgeEdge') {
          return this.apronBackSplash.positionOfEdgeOrBacksplash;
        }

        return null;
      }

      return this.getDefault(configuration_1.ConfigurationKeys.ApronBackSplash, ApronBackSplashKeys.PositionOfEdgeOrBacksplash).default;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ApronBackSplash.prototype, "backsplashHeight", {
    get: function get() {
      if (this.apronBackSplash) {
        if (this.surgeEdgeOrBackSplash === 'withBackSplash') {
          return this.apronBackSplash.backsplashHeight;
        }

        return null;
      }

      return this.getDefault(configuration_1.ConfigurationKeys.ApronBackSplash, ApronBackSplashKeys.BacksplashHeight).default;
    },
    enumerable: true,
    configurable: true
  });
  return ApronBackSplash;
}(configuration_1.Configuration);

exports.ApronBackSplash = ApronBackSplash;